import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import './TermsAndConditionsPage.css';
import { Button } from '@material-ui/core';
import TermsAndConditionsView from '../../widgets/TermsAndConditions/TermsAndConditionsView';

const TermsAndConditionsPage = (props) => {
  return (
    <div>
      <div>
        <h1 className="customer-renewal-view-logo">
          <img src={props.logo} alt="C3 Link" />
        </h1>
      </div>
      <div className="terms-and-conditions-page">
        <div className="terms-body">
          <TermsAndConditionsView terms={props.termsAndConditions} />
        </div>
        <Button
          onClick={() => props.onAgree(props.termsAndConditions.type)}
          className="approve-button"
        >
          {props.intl.formatMessage({
            id: 'terms_acknowledgement'
          })}
        </Button>
      </div>
    </div>
  );
};

TermsAndConditionsPage.propTypes = {
  onAgree: PropTypes.func.isRequired,
  termsAndConditions: PropTypes.object.isRequired
};

export default injectIntl(TermsAndConditionsPage);
